import request from '@/utils/request'


// 查询业态分类列表
export function listBusinessCategory(query) {
  return request({
    url: '/business/business/category/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询业态分类分页
export function pageBusinessCategory(query) {
  return request({
    url: '/business/business/category/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询业态分类详细
export function getBusinessCategory(data) {
  return request({
    url: '/business/business/category/detail',
    method: 'get',
    params: data
  })
}

// 新增业态分类
export function addBusinessCategory(data) {
  return request({
    url: '/business/business/category/add',
    method: 'post',
    data: data
  })
}

// 修改业态分类
export function updateBusinessCategory(data) {
  return request({
    url: '/business/business/category/edit',
    method: 'post',
    data: data
  })
}

// 删除业态分类
export function delBusinessCategory(data) {
  return request({
    url: '/business/business/category/delete',
    method: 'post',
    data: data
  })
}
